import { Navigate, Outlet, useMatches } from 'react-router'
import { useAppSelector } from '~/app/hooks'
import { PATH_NAME } from '~/constants'
import { selectAuth } from '~/redux/features'
import { CheckRole } from '~/utils'
export function RoleGuardOutlet() {
  const { roles } = useAppSelector(selectAuth)
  const matches = useMatches()

  // Find the nearest handle with requireRoles (prefer child route, fallback to parent route)
  const handle = ([...matches].reverse().find(x => (x.handle as { requireRoles?: string[] })?.requireRoles)?.handle || {}) as {
    requireRoles?: string[]
  }

  let roleOk = false
  if (handle?.requireRoles && Array.isArray(handle.requireRoles)) {
    roleOk = CheckRole(handle.requireRoles, roles)
  } else {
    roleOk = true
  }

  return roleOk ? <Outlet /> : <Navigate to={PATH_NAME.NOT_AUTHORIZED.path} />
}
